export enum MoyenPaiement {
     cb = 0,
     cheque = 1,
     virement = 2,
     paypal = 3,
     cb3x = 4
}
